import ApiService from '@/services/apiService';
import cloneDeep from 'lodash/cloneDeep';

export default {
  props: {},
  data: function () {
    return {
      scopeDetails: {},
    };
  },
  methods: {
    /**
     * will fetch the hierarchy-tree for the given scope and create a breadcrumb path,
     * as well as holding all scopes ancestors in a sorted list.
     * Is cached in `scopeDetails`, also for outside usage (e.g. `matchAllAccesses` in the user-list)
     */
    async fetchScopeDetails(scope) {
      if (this.scopeDetails[scope.id]) {
        return this.scopeDetails[scope.id];
      }

      const iterateToLeaf = (details, element) => {
        const hierarchyElement = {
          id: element.id,
          parentId: element.parent,
          name: element.name,
        };

        const breadcrumDetails = details
          ? {
              crumbPath: `${details.crumbPath} / ${element.name}`,
              hierarchy: details.hierarchy.concat([hierarchyElement]),
            }
          : { crumbPath: element.name, hierarchy: [hierarchyElement] };
        if (!element.children || element.children.length === 0) {
          return { ...breadcrumDetails, ...hierarchyElement };
        }
        return iterateToLeaf(breadcrumDetails, element.children[0]);
      };

      const emptyDetails = { crumbPath: '', hierarchy: [] };

      return ApiService.userScopesFetchSearchResult(null, 'UserManagement', 'read', null, ['no-children'], scope.id)
        .then((res) => {
          const rootScope = res && Array.isArray(res.scopes) ? res.scopes[0] : null;
          this.scopeDetails[scope.id] = rootScope ? iterateToLeaf(null, rootScope) : emptyDetails;
          this.scopeDetails = cloneDeep(this.scopeDetails);
          return this.scopeDetails[scope.id];
        })
        .catch((error) => {
          console.error('Failed to fetch breadcrumb scope details for scope', scope.id, error);
          this.scopeDetails[scope.id] = emptyDetails;
          this.scopeDetails = cloneDeep(this.scopeDetails);
          return this.scopeDetails[scope.id];
        });
    },
  },
};
